import { useLISFinalizedDiagnosis } from "shared/hooks/useDiagnosis";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import Sidebar from "./Sidebar";

type FlatDiagnosisDialogProps = {
  caseDetailObject: CaseDetailState;
};

const WplDiagnosisDialog = ({ caseDetailObject }: FlatDiagnosisDialogProps) => {
  const diagnosis = useLISFinalizedDiagnosis(caseDetailObject);

  return (
    <Sidebar isWide>
      <div className="Sidebar__contentContainer">
        <dl>
          <dt>DIAGNOSIS</dt>
        </dl>
        <dd className="diagnosis-box">
          {(diagnosis?.diagnosis || "").split(/[\r\n]+/).map((line, i) => (
            <div key={i}>
              {line
                .trim()
                .replace("&lt;", "<")
                .replace("&gt;", ">")
                .replace("&nbsp;", " ")
                .replace("&amp;", "&")}
            </div>
          ))}
        </dd>
      </div>
    </Sidebar>
  );
};

export default WplDiagnosisDialog;
